import Vue from 'vue'
import Vuex from 'vuex'
import {Auth} from 'aws-amplify'
import axios from 'axios'
import {errorMessageHandler} from "../_utils/errorMessageHandler";
import {parseCommunityNameURI} from "../_utils/parseCommunityNameURI";
import {
    getProject, deleteCommunityFromProject, addCommunityToProject, updateProject,
    updateCommunityInProject, lockCommunityInProject, unlockCommunityInProject
} from '../services/project.service'


Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        AWSToken: null,
        email: '',
        accessToken: null,
        communities: [],
        project: null,
    },
    getters: {
        communitiesWatch: state => () => state.communities
    },
    mutations: {
        setAWSToken(state, newVal) {
            state.AWSToken = newVal
        },
        setAccessToken(state, newVal) {
            state.accessToken = newVal
        },
        setEmail(state, newVal) {
            state.email = newVal
        },
        updateCommunities(state, newVal) {
            state.communities = newVal.sort((a, b) => b.created_at > a.created_at ? 1 : -1)
                .map((c, idx) => ({...c, id: idx}))
        },
        updateCommunity(state, community) {
            state.communities = state.communities.map(c => {
              if (c && c.key.namespace == community.key.namespace
                    && c.key.name == community.key.name) {
                return community;
              }
              else {
                return c;
              }
            });
        },
        deleteCommunity(state, key) {
            state.communities = state.communities.filter(c => c.key.name !== key.name)
        },
        addCommunity(state, newVal) {
            state.communities.unshift(newVal);
        },
        updateCommunityKPIs(state, payload) {
            const key = payload.key;
            const usersShare = payload.usersShare;
            const usersCount = payload.usersCount;
            const startDate = payload.startDate;
            const endDate = payload.endDate;
            const type = payload.type;
            const nProjectsUsing = payload.nProjectsUsing;
            state.communities = state.communities.map(c => {
                if (c.key.name === key.name) {
                    return {
                        ...c, usersShare: usersShare, usersCount: usersCount, type: type,
                        startDate: startDate, endDate: endDate,
                        nProjectsUsing: nProjectsUsing
                    }
                } else {
                    return c
                }
            })
        },
        updateCommunityErr(state, payload) {
            const key = payload.key;
            const errMessage = payload.errMessage;
            state.communities = state.communities.map(c => {
                if (c.key.name === key.name) {
                    return {...c, errMessage: errMessage}
                } else {
                    return c
                }
            })
        },
        setProject(state, project) {
            state.project = project
        },
        updateCommunitiesInProject(state, communities) {
            state.project.configuration.communities = communities
        },
        updateProject(state, newState) {
            state.project = newState
        },
        updateAnalysesInProject(state, newState) {
            state.project.configuration.analyses = newState
        }
    },
    actions: {
        async authenticate() {
            return await Auth.currentSession().then(resp => {
                store.commit('setAWSToken', resp.getIdToken().jwtToken);
                store.commit('setEmail', resp.getIdToken().payload.email);
                return axios.get('/iam/v1/authorize', {
                    headers: {Authorization: "Bearer " + resp.getIdToken().jwtToken}
                }).then(resp => {
                    store.commit('setAccessToken', resp.data.access_token);
                    return true
                }).catch(err => false)
            }).catch(err => false);
        },
        async getAccessToken(store) {
            return store.state.accessToken
        },
        async setCommunities(store) {
            const token = store.state.accessToken;
            await axios.get('/community',
                {headers: {Authorization: "Bearer " + token}})
                .then(resp => {
                    store.commit('updateCommunities', resp.data)
                });
            return store.state.communities
        },
        async getCommunities(store) {
            return store.state.communities
        },
        async deleteCommunity(store, key) {
            const token = store.state.accessToken;
            return await axios.delete(parseCommunityNameURI(`/community/`, key),
                {headers: {Authorization: "Bearer " + token}})
                .then(resp => {
                    store.commit("deleteCommunity", key)
                })
        },
        async addCommunity(store, community) {
            const token = store.state.accessToken;
            return await axios.post('/community/', community,
                {
                    headers: {Authorization: "Bearer " + token}
                })
                .then(resp => {
                    store.commit('addCommunity', resp.data);
                    store.dispatch('communityKPIs', resp.data.key)
                });
        },
        async editCommunity(store, config) {
            const token = store.state.accessToken;
            await axios.put("/community/" + encodeURI(`${config.name.namespace}.\"${config.name.name}\"`), JSON.stringify(config.query),
                {
                    headers: {Authorization: "Bearer " + token}
                }).then(resp => {
                store.dispatch('communityKPIs', resp.data.key)
            }).catch(err => err);
            return store.state.communities;
        },
        async communityKPIs(store, params) {
            const key = params.key
            const start = params.dateRange.start
            const now = params.dateRange.now

            const token = store.state.accessToken;
            const reqBody = {
                "startDate": `${start}`,
                "endDate": `${now}`,
                "query": `existing: ${key.namespace}."${key.name}"`
            };
            await axios.post("/community/kpis/", reqBody, {
                headers: {Authorization: "Bearer " + token}
            }).then(resp => {
                const usersShare = resp.data.usersShare;
                const usersCount = resp.data.usersCount;
                const type = resp.data.type;
                const nProjectsUsing = resp.data.nProjectsUsing;
                store.commit("updateCommunityKPIs", {
                    key: key,
                    usersShare: usersShare,
                    usersCount: usersCount,
                    type: type,
                    nProjectsUsing: nProjectsUsing,
                })
            }).catch((err) => {
                store.commit("updateCommunityErr", {
                    key: key,
                    errMessage: errorMessageHandler(err.toString())
                });
            })
        },
        async getCommunityQuery(store, key) {
            const token = store.state.accessToken;
            return await axios.get(parseCommunityNameURI(`/community/query/`, key), {
                headers: {Authorization: "Bearer " + token}
            }).then(resp => resp.data)
        },
        async getCommunityVE(store, query) {
            const token = store.state.accessToken;
            return await axios.post("/community/query/verify", JSON.stringify(query), {
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-type": "application/json"
                }
            }).then(resp => resp.data)
        },
        async getCommunityQueryVE(store, ve) {
            const token = store.state.accessToken;
            return await axios.post("/community/query/verifyVE", ve, {
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-type": "application/json"
                }
            }).then(resp => resp.data)
        },
        // Project related
        setProject(store, projectId) {
            if (projectId !== null) {
                return getProject(projectId).then(project => {
                    // Start of temporary solution
                    project.color = '#112060';
                    // End of temporary solution

                    store.commit("setProject", project);
                }).catch((err) => err)
            } else {
                store.commit("setProject", null);
            }
        },
        getProject(store) {
            return store.state.project
        },
        deleteCommunityFromProject(store, config) {
            deleteCommunityFromProject(config.projectId, config.communityId).then(communities => {
                getProject(config.projectId).then(project => {
                    // Refresh communities
                    store.commit("updateCommunitiesInProject", project.configuration.communities);
                    // Refresh analyses
                    store.commit("updateAnalysesInProject", project.configuration.analyses);
                });
            }).catch((err) => err)
        },
        updateCommunityInProject(store, config) {
            updateCommunityInProject(config.projectId, config.communityId, config.community).then(community => {
                // swap modified community in the list
                const communities = store.state.project.configuration.communities.map(c => {
                    return c.id == community.id ? community : c
                });

                // Refresh analyses
                getProject(config.projectId).then(project => {
                    store.commit("updateAnalysesInProject", project.configuration.analyses);
                });
                store.commit("updateCommunitiesInProject", communities);
            }).catch((err) => err)

        },
        addCommunityToProject(store, config) {
            addCommunityToProject(config.projectId, config.community).then(community => {
                const communities = store.state.project.configuration.communities.concat([community]);
                store.commit("updateCommunitiesInProject", communities);
            }).catch((err) => err)
        },
        lockCommunityInProject(store, config) {
            lockCommunityInProject(config.projectId, config.communityId).then(community => {
                // swap modified community in the list
                const communities = store.state.project.configuration.communities.map(c => {
                    return c.id == community.id ? community : c
                });
                console.log("store lockCommunityInProject then");
                console.log(communities);
                store.commit("updateCommunitiesInProject", communities);
            }).catch((err) => {
              console.log(err)
            });
        },
        unlockCommunityInProject(store, config) {
            unlockCommunityInProject(config.projectId, config.communityId).then(community => {
                // swap modified community in the list
                const communities = store.state.project.configuration.communities.map(c => {
                    return c.id == community.id ? community : c
                });
                console.log("store unlockCommunities then");
                console.log(communities);
                store.commit("updateCommunitiesInProject", communities);
            }).catch((err) => {
              console.log(err)
            });
        },
        updateProject(store, config) {
            return updateProject(config.projectId, config.partial).then(project => {
                store.commit('updateProject', project)
            })
        },
        async lockCommunity(store, key){
            const token = store.state.accessToken;
            return await axios.put(parseCommunityNameURI(`/community/`, key) + "/lock",
                JSON.stringify(""),
                {headers: {Authorization: "Bearer " + token}})
                .then(resp => {
                  console.log("Locked!");
                  store.commit('updateCommunity', resp.data);
                })
        },
        async unlockCommunity(store, key){
            const token = store.state.accessToken;
            return await axios.delete(parseCommunityNameURI(`/community/`, key) + "/lock",
                {headers: {Authorization: "Bearer " + token}})
                .then(resp => {
                  console.log("UnLocked!");
                  var community = store.state.communities.find(c => {
                    return c.key.namespace == key.namespace
                           && c.key.name == key.name;
                  });
                  if (community) {
                    store.commit('updateCommunity', {...community, is_locked: false});
                  }
                })
        }
    },
});
